import { useState, useEffect, useRef } from "react";
import { Badge } from "@/components/ui/badge";
const categories = [];
export default function CategoryQuickLinksCopy() {
  const [signupVisible, setSignupVisible] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="relative bg-background text-foreground overflow-hidden py-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/driveway_background.png)]">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Space+Mono:wght@400;700&display=swap');`}</style>

      <div className={`transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}>
        

        
      </div>
    </section>;
}